import { FormattedMessage } from 'react-intl';
export const PRIVATE_AREA_VIEW_ROUTE = 'private-area';
export const STATUS_VOCABULARY_ID = 'fbc.addon.LocationStatusesVocabulary';

export const MANAGER_STATUS_FLOW = {
  1: [
    {
      to: '3',
      title: <FormattedMessage id="Reject" defaultMessage="Reject" />,
      className: 'rejected-color',
    },
    {
      to: '2',
      title: <FormattedMessage id="Allow" defaultMessage="Allow" />,
      className: 'primary-color',
    },
  ],
  2: [
    {
      to: '1',
      title: <FormattedMessage id="To Pending" defaultMessage="To Pending" />,
      className: 'pending-color',
    },
    {
      to: '3',
      title: <FormattedMessage id="Reject" defaultMessage="Reject" />,
      className: 'rejected-color',
    },
  ],
  3: [
    {
      to: '1',
      title: <FormattedMessage id="To Pending" defaultMessage="To Pending" />,
      className: 'pending-color',
    },
    {
      to: '2',
      title: <FormattedMessage id="Allow" defaultMessage="Allow" />,
      className: 'primary-color',
    },
  ],
  4: [
    {
      to: '2',
      title: <FormattedMessage id="Allow" defaultMessage="Allow" />,
      className: 'primary-color',
    },
  ],
};

export const CONTACTS = {
  es: 'contacto',
  en: 'contact',
  eu: 'kontaktua',
};
